/**
 * @tabler/icons-react v2.44.0 - MIT
 */

import createReactComponent from '../createReactComponent.js';

var IconChartAreaLine = createReactComponent("chart-area-line", "IconChartAreaLine", [
  ["path", { d: "M4 19l4 -6l4 2l4 -5l4 4l0 5l-16 0", key: "svg-0" }],
  ["path", { d: "M4 12l3 -4l4 2l5 -6l4 4", key: "svg-1" }]
]);

export { IconChartAreaLine as default };
//# sourceMappingURL=IconChartAreaLine.js.map
